<template>
  <modal v-if="modalStateFor(modalId).isVisible" :state="modalStateFor(modalId)" :index="index" @toggle-modal="reset">
    <h4 class="modal-title">Document Quick Jump</h4>
    <input
      id="quick-jump-search"
      type="text"
      v-model="searchInput"
      v-on:keyup.enter="submit"
      v-on:keydown.down="handleDown"
      v-on:keydown.up="handleUp"
      ref="quickJumpInput"
    />
    <scroll-area>
      <ul class="list-group">
        <li :class="liClass(index)" v-for="(item, index) in results" :key="item.id">
          <a :style="getColor(item)" :href="item.link"><icon :class="getIcon(item)"></icon> {{ item.title }}</a>
        </li>
      </ul>
    </scroll-area>
  </modal>
</template>


<script lang="ts">
import Vue from "vue";
import { ModalID } from "~/enums/modalID";
import { BooleanHelper } from "~/helpers/booleanHelper";
import { IModalState } from "~/interfaces/modalInterfaces";
import Selected from "~/state/modules/selected";

export default Vue.extend({
  props: {
    state: {
      type: Object,
    },
  },
  data() {
    return {
      searchInput: "",
      results: [],
      selectedResult: 0,
      timeout: null,
    };
  },
  methods: {
    submit(event) {
      event.preventDefault();
      if (this.results.length > 0) {
        window.location.href = this.results[this.selectedResult].link;
      }
    },
    handleDown(event) {
      event.preventDefault();
      if (this.selectedResult < this.results.length - 1) {
        this.selectedResult += 1;
      }
    },
    handleUp(event) {
      event.preventDefault();
      if (this.selectedResult > 0) {
        this.selectedResult -= 1;
      }
    },
    liClass(index) {
      if (index === this.selectedResult) {
        return "list-group-item bg-light";
      } else {
        return "list-group-item";
      }
    },
    toggleModal() {
      this.showModal(this.modalId, BooleanHelper.toggle(this.modalState.isVisible));
      setTimeout(() => {
        this.$refs.quickJumpInput.focus();
      }, 300);
    },
    reset(event) {
      this.showModal(this.modalId, BooleanHelper.toggle(this.modalState.isVisible));
    },
    getColor(document) {
      switch (document.type) {
        case "content/detail_view":
          return "color: #257d93";
        case "content/list_view":
          return "color: #9e6710";
        case "object_model":
          return "color: #20723b";
        case "form":
          return "color: #3876cc";
        case "mapping":
          return "color: #bf4a67";
        case "process_flow":
          return "color: #c84d11";
        case "license":
          return "color: #AF08AA";
        case "certificate":
          return "color: #e72113;";
        case "public_profiles":
          return "color: #e72113;";
      }
    },
    getIcon(document) {
      switch (document.type) {
        case "content/detail_view":
          return "icon detail-view";
        case "content/list_view":
          return "icon list-document";
        case "object_model":
          return "icon model";
        case "form":
          return "icon form";
        case "mapping":
          return "icon mapping-document";
        case "process_flow":
          return "icon process-flow";
        case "license":
          return "icon license";
        case "certificate":
          return "icon certificate";
        case "public_profiles":
          return "icon public-profiles";
      }
    },
    async performSearch(value) {
      if (value.trim().length > 0) {
      const org = Selected.organization.get();
      const data = await $.ajax({
        url: `/organizations/${org.id}/search_documents?q=${value}&include_extra_folder_info=true`,
        type: "GET",
      });
      this.selectedResult = 0;
      this.results = data.documents;
      }
    },
  },
  computed: {
    modalId(): ModalID {
      return this.vueModalID.quickJump;
    },
    modalState(): IModalState {
      return this.modalStateFor(this.modalId);
    },
  },
  watch: {
    searchInput: function (newVal) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.performSearch(newVal);
      }, 300);
    },
  },
});
</script>

